<template>
  <span
    v-if="project.attributes.skip_customer"
    class="flex size-5 shrink-0 items-center justify-center rounded-md bg-gray-200"
  >
    <FontAwesomeIcon
      :icon="['far', 'memo']"
      class="text-gray-500"
      size="sm"
    />
  </span>
  <Avatar
    v-else
    class="shrink-0"
    size="20"
    format="square"
    :src="project.attributes.picture_login_url_m"
    :username="project.attributes.name"
  />
  <span class="truncate font-semibold">{{ project.attributes.name }}</span>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

defineProps({
  project: { type: Object, required: true },
});
</script>
